import type { AnalysisResult } from '../types';

interface AnalysisResultsProps {
    results: AnalysisResult[];
    onRemoveLane: (symbol: string) => void;
}

// function getDomainFromUrl(url: string): string | null {
//     try {
//         const { hostname } = new URL(url);
//         return hostname;
//     } catch {
//         return null;
//     }
// }

const getLanguageFlag = (language?: string): JSX.Element => {
    const languageMap: Record<string, string> = {
        'english': 'gb',
        'german': 'de',
        'chinese': 'cn',
        'japanese': 'jp',
        'korean': 'kr',
        'french': 'fr',
        'spanish': 'es',
        'italian': 'it',
        'portuguese': 'pt',
        'russian': 'ru',
    };

    const countryCode = languageMap[language?.toLowerCase() || ''] || '';

    return countryCode ? (
        <span className={`fi fi-${countryCode}`} title={language}></span>
    ) : (
        <span title="Unknown">🌐</span>
    );
};

export function AnalysisResults({ results, onRemoveLane }: AnalysisResultsProps) {
    if (results.length === 0) {
        return (
            <div className="kanban-board">
                <div className="kanban-lane">
                    <div className="kanban-lane-header">
                        <span>Keine Ergebnisse</span>
                    </div>
                    <div className="kanban-card neutral">
                        <h3>Keine Informationen gefunden</h3>
                        <p>Es wurden keine Ergebnisse gefunden, die Ihren Suchkriterien entsprechen.</p>
                    </div>
                </div>
            </div>
        );
    }

    const groupedBySymbol = results.reduce((acc, result) => {
        if (!result || !result.symbol) return acc;

        if (!acc[result.symbol]) {
            acc[result.symbol] = [];
        }
        acc[result.symbol].push(result);
        return acc;
    }, {} as Record<string, AnalysisResult[]>);

    return (
        <div className="kanban-board">
            {Object.entries(groupedBySymbol).map(([symbol, symbolResults]) => (
                <div key={symbol} className="kanban-lane">
                    <div className="kanban-lane-header">
                        <span>{symbol}</span>
                        <button
                            className="lane-close-btn"
                            onClick={() => onRemoveLane(symbol)}
                            title="Lane schließen"
                        >
                            ×
                        </button>
                    </div>
                    {(symbolResults as AnalysisResult[]).map((result: AnalysisResult) => {
                        const sentiment = result.sentiment?.toLowerCase() || 'neutral';

                        return (
                            <div
                                key={result.id}
                                className={`kanban-card ${sentiment}`}
                            >
                                <div className="card-header">
                                    <h3>
                                        {result.url ? (
                                            <a href={result.url} target="_blank" rel="noopener noreferrer">
                                                {result.symbol}
                                            </a>
                                        ) : (
                                            result.symbol
                                        )}
                                    </h3>
                                    <span className="language-flag">
                                        {getLanguageFlag(result.language)}
                                    </span>
                                </div>
                                <p>{result.summary || 'Keine Zusammenfassung verfügbar'}</p>
                                <div className="meta">
                                    {/* <span>Confidence: {result.confidence ? (result.confidence * 100).toFixed(0) : '0'}%</span> */}
                                    <span><a className="link-yellow" href={result.url} target="_blank" rel="noopener noreferrer">{result.source || 'N/A'}</a></span>
                                    <span>{new Date(result.timestamp).toLocaleDateString()}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
}